import React, { useEffect, useRef, useState } from "react";
import { useStateValue } from "../../../StateProvider";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import {
  addNotification,
  addProject,
  getAddNotificationData,
  getAddProjectData,
  getNotification,
  getTableData,
  updateProject,
} from "../../../apiCall";
import "./AddNotification.scss";
import Select from 'react-select'


import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import EncodeAprxDuration from "../../../utils/EncodeAprxDuration";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import DecodeAprxDuration from "../../../utils/DecodeAprxDuration";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import { isAdmin } from "../../../utils/adminAccess";
import { TRAN_TYPE } from "../../../Constants";
import { formatDateTimetoAmPm } from "../../../utils/FormateDate";
import { convertToUserOptions, customStyles } from "../../../utils/ConvertToOptions";
import { validateNoBlankSpaces } from "../../../utils/formValidation";
function convertToDateTimeLocalString(dateString) {
  console.log(dateString)
  const date = new Date(String(dateString));
  console.log(date)

  // Get date components
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  // Format to `YYYY-MM-DDTHH:MM`
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

const AddNotification = ({
  setActiveTab,
  isStaffNotification,
  notificationId = "",
  TranMID,
  TranType,
  setNotificationCount,
  refetchNotificationList,
  detailRefetch,
  notifictionType,
  setTitle,
  ProjectAllocBy,
  ProjectLead,
  TaskAllocBy,
  TaskLead,
}) => {
  const [tab, setTab] = useState("information");
  const [{ userInfo }, dispatch] = useStateValue();
  const [profileImage, setSetProfileImage] = useState("");
  const [notificationStatus, setNotificationStatus] = useState("Pending");
  const [isSaveAndAddTask, setIsSaveAndAddTask] = useState(false);
  const [isSaveAndEditeSubtask, setIsSaveAndEditeSubtask] = useState(false);
  const [editTaskId, setEditTaskId] = useState();
  const [commentCount, setCommentCount] = useState(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userFilter = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const statusFilter = searchParams.get("project_status_filter");
  const searchFilter = searchParams.get("project_search_filter");
  const notificationIDParams = searchParams.get("notification_id");
  const [title, setNTitle] = useState("Add NotificationId");
  const { projectId } = useParams();

  // # attachmentCount **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  // # attachmentCount **************************************************

  const navigate = useNavigate();




  // ********************************************** form start ****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    reset,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      TranType: 2,
      SentTo: ""
    },
  });
  const watchedFields = watch();
  const onSubmit = async (data) => {
    // **************************** formate dates start ****************************
    if (!data.SentTo) {

      setError("SentTo", {
        type: "manual",
        message: "Sent to is required.",
      });
      return ""
    }
    dispatch({ type: "SET_LOADING", status: true });

    try {
      let re;
      if (notificationId||notificationIDParams ) {

      } else {
        re = await addNotification(data);
        if (re?.status === 201) {
          reset();
          if (data.TranType !== 2) {

            // setNotificationCount((prev) => prev + 1);
            detailRefetch()
          }
          setActiveTab("notifictionList");
          handleTitleChnage();
          refetchNotificationList();
          if(isStaffNotification){
            navigate("/notification")
          };


          toast.success(re?.data?.message);
        } else if (re?.response) {
          toast.error(re?.response?.data?.message);
        }
      }
    } catch { }
    dispatch({ type: "SET_LOADING", status: false });
  };
  // ********************************************** form end ****************************************************

  // ********************************************** get data start ****************************************************
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["new-notification-form-data"],
    queryFn: async () => {
      // Perform the API call to fetch company info
      dispatch({ type: "SET_LOADING", status: true });
      try {
        const response = await getAddNotificationData();
        if (response?.status === 200) {
          setFormDefaultData(response.data.data);
          if (TranMID) {
            detailRefetch();
          }
          if (notificationId || notificationIDParams) {
            taskDetailRefetch();
          }
        } else if (response?.response) {
          toast.error(response.response.data.status);
        }

        // return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
      }
      dispatch({ type: "SET_LOADING", status: false });
    },
  });
  const [formDefaultData, setFormDefaultData] = useState(
    data?.status === 200 ? data.data.data : {}
  );
  const [notificationData, setNotificationData] = useState(
    {}
  );

  // ********************************************** get data end ****************************************************
  // ********************************************** get task data start****************************************************
  const fetchNotification = async () => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });
    try {
      const response = await getNotification(notificationId||notificationIDParams);

      if (response?.status === 200) {
        // setTaskTempList(response.data.data);

        console.log(response.data?.data);
        setNotificationData(response.data?.data)
        setNotificationStatus(response.data?.data?.Status?.text);
        setValue("TranMID", response.data?.data?.TranMID);
        setValue("TranType", response.data?.data?.TranType?.idx);
        setValue("SentBy", response.data?.data?.SentBy);
        setValue("SentTo", response.data?.data?.SentTo);
        setValue("Subject", response.data?.data?.Subject);
        setValue("Description", response.data?.data?.Description);
        setValue(
          "DtTime",
          response.data?.data?.DtTime
        );
        console.log(response.data?.data?.TranType?.idx !== 2)
        if (response.data?.data?.TranType?.idx !== 2) {
          try {
            const re = await getTableData(
              response.data?.data?.TranType?.idx
            );
            if (re?.status === 200) {
              console.log(re.data.data);
              setTranDataList(re?.data?.data ? re.data?.data : []);
            } else if (response?.response) {
              toast.error(re?.re?.data?.message);
            }
          } catch (error) {
            console.error("Error fetching data:", error); // Log any errors that occur
            throw error;
          }
        }
        dispatch({ type: "REFETCH_NOTIFICATION_COUNT", status: true });

        // queryClient.invalidateQueries("unread-notification-count");
        if (response.data?.data?.ReadDtTm) {
          setValue(
            "ReadDtTm",
            response.data?.data?.ReadDtTm
          );
        }
      } else if (response?.response) {
        toast.error(response.response.data.message);
      }

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
    }
    dispatch({ type: "SET_LOADING", status: false });
  };
  const { data: taskTempDetail, refetch: taskDetailRefetch } = useQuery({
    queryKey: ["notification-detail"],
    queryFn: fetchNotification,
    enabled: false,
    // staleTime: Infinity,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const fetchTranList = async () => {
    // Perform the API call to fetch company info
    try {
      const response = await getTableData(
        TranType ? TranType : watchedFields.TranType
      );
      if (response?.status === 200) {
        console.log(response.data.data);
        setTranDataList(response?.data?.data ? response.data?.data : []);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const { data: tranData, refetch: tranDataRefetch } = useQuery({
    queryKey: ["tran-data-list"],
    enabled: TranType ? true : false,

    queryFn: () => fetchTranList(),

    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const [tranDataList, setTranDataList] = useState([]);
  // ********************************************** get task data end ****************************************************
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!(notificationId || notificationIDParams)) {
      setValue("SentBy", userInfo?.user_code);
    }
  }, [setValue, userInfo, notificationId,notificationIDParams]);

  useEffect(() => {
    if (notificationId ||notificationIDParams) {
      setNTitle("Notification");
    }
    if (!(notificationId||notificationIDParams)) {
      setNTitle("Add Notification");
    }

  }, [notificationId,notificationIDParams]);

  const [funHandler, setFunHandler] = useState();
  const [confirmationShow, setConfirmationShow] = useState(false);
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };

  const formRef = useRef(null);
  useEffect(() => {
    if (TranType) {
      setValue("TranType", TranType);
    }
    if (TranMID) {
      setValue("TranMID", TranMID);
    }
  }, [TranMID, TranType]);
  useEffect(() => {

    if (!TranType && watchedFields.TranType === 2) {
      setTranDataList(formDefaultData?.users_list ? formDefaultData?.users_list : [])
      setValue("TranMID", userInfo.user_code)

    }
    else if (!TranType) {
      setValue("TranMID", notificationData?.TranMID)

    }

  }, [watchedFields.TranType, formDefaultData?.users_list]);
  useEffect(() => {

    if (!TranType && watchedFields.TranType === 2) {
      setValue("TranMID", watchedFields.SentTo)
    }
    else if (!TranType) {
      setValue("TranMID", notificationData?.TranMID)

    }

  }, [watchedFields.TranType, watchedFields.SentTo]);

  const handleTitleChnage = () => {
    if (TranType === 7) {
      setTitle(TranMID ? "Update Task" : "Add Task");
    }

    else if (TranType === 6) {
      setTitle(TranMID ? "Update Project" : "Add Project");


    } else if (TranType === 2) {
      setTitle(TranMID ? "Update Staff" : "Add Staff");
    }
  };
  const [screenWidth, setScreenWidth] = useState()
  useEffect(() => {
    setScreenWidth(window.innerWidth)
  }, [window.innerWidth])


 
  return (
    <div id={`${isStaffNotification ? "app-content" : ""}`}>
      {/* Container fluid */}
      <div
        className={`${isStaffNotification ? "app-content-area  mb-10" : ""}`}
      >
        <div className="container-fluid ">
          <div
            className={`${isStaffNotification ? "" : "d-none"
              } mx-n6 mt-n6 pt-6 mb-6 header`}
          >
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  {/* <div className="mb-6 mb-lg-0"> */}
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="">
                      <h1 className="mb-0 h3 ">{title}</h1>
                    </div>
                    <div lassName="status ">
                      <div
                        className="mb-0"
                        style={{ fontSize: "20px", fontWeight: "bold" }}
                      >
                        {notificationStatus}
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-between px-6">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab ">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${tab === "information"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                        onClick={() => {
                          setTab("information");
                          setNTitle((notificationId ||notificationIDParams) ? "Notification" : "Add Notification");
                        }}
                      >
                        Information
                      </div>
                    </li>
                  </ul>
                  {/* <div className="status fs-3">
                    <h3>{taskStatus}</h3>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        // <form onSubmit={handleSubmit(onSubmit)}>
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body" style={{ padding: "10px" }}>
                              {/* form */}
                              <div className="row">
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    For
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    value={watchedFields.TranType}
                                    // value={2}
                                    disabled
                                    className="form-select"
                                    {...register("TranType", {
                                      required: "TranType is required",
                                      onChange: (e) => {
                                        if (e.target.value !== 2) {
                                          setTimeout(() => {
                                            tranDataRefetch();
                                            setValue("TranMID", "");
                                          }, 100);
                                        }
                                      },
                                    })}
                                  >
                                    <option value="" disabled>
                                      select
                                    </option>

                                    {TRAN_TYPE?.map((item) => (
                                      <option value={item.value}>
                                        {item.key}
                                      </option>
                                    ))}
                                  </select>

                                  {errors.TranType && (
                                    <div className="error">
                                      {errors.TranType.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    Name
                                    <span className="text-danger">*</span>
                                  </label>

                                  <select
                                    value={watchedFields.TranMID}
                                    disabled={
                                      notificationId || notificationIDParams||
                                        watchedFields.TranType === 2 ||
                                        TranType
                                        ? true
                                        : false
                                    }
                                    className="form-select"
                                    {...register("TranMID", {
                                      required: "Is required",
                                    })}
                                  >
                                    <option value="" disabled>
                                      select option{" "}
                                    </option>
                                    {tranDataList.length
                                      ? tranDataList.map((item) => (
                                        <option value={item?.ID ? item.ID : item}>
                                          {item?.Name ? item.Name : item}
                                        </option>
                                      ))
                                      : ""}
                                  </select>

                                  {errors.TranMID && (
                                    <div className="error">
                                      {errors.TranMID.message}
                                    </div>
                                  )}
                                </div>
                                {/* {
                                  screenWidth >= 770 ?
                                    <div className="mb-4 col-md-4 col-6">
                                      <label className="form-label">
                                        Sent{" "}
                                      </label>
                                      <div
                                        className="input-group me-3 flatpickr rounded flatpickr-input"
                                        readOnly="readonly"
                                      >
                                        <input
                                          className="form-control "
                                          type="datetime-local"
                                          placeholder="Select Date"
                                          aria-describedby="basic-addon2"
                                          min="1000-01-01T00:00"
                                          max="9999-12-31T23:59"
                                          disabled
                                          {...register("DtTime", {
                                          })}
                                        />
                                      </div>
                                      {errors.DtTime && (
                                        <div className="error">
                                          {errors.DtTime.message}
                                        </div>
                                      )}
                                    </div> : <></>
                                } */}
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    From <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter From"
                                    disabled
                                    {...register("SentBy", {
                                      required: "From is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.SentBy.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-6">
                                  <label className="form-label">
                                    To
                                    <span className="text-danger">*</span>
                                  </label>
                                  {/* <select
                                    value={watchedFields.ProjLead}
                                    className="form-select"
                                    disabled={notificationId ? true : false}
                                    {...register("SentTo", {
                                      required: "To is required",
                                    })}
                                  >
                                    <option value="">select user</option>

                                    {formDefaultData?.users_list?.map(
                                      (item) => (
                                        <option value={item}>{item}</option>
                                      )
                                    )}
                                  </select> */}
                                  <Select
                                    // className="form-select"
                                    styles={customStyles}
                                    value={watchedFields.SentTo ? { label: watchedFields.SentTo, value: watchedFields.SentTo } : { label: "Select a user", value: "" }}
                                    // value={{ label: watchedFields.ProjLead, value: watchedFields.ProjLead }}

                                    isDisabled={(notificationId ||notificationIDParams) ? true : false}

                                    placeholder="Select user."
                                    onChange={(option) => {
                                      setValue("SentTo", option.value)
                                      clearErrors("SentTo");
                                    }}

                                    options={[{ label: "Select a user", value: "", isDisabled: true }, ...convertToUserOptions(formDefaultData?.users_list)]}
                                  />

                                  {errors.SentTo && (
                                    <div className="error">
                                      {errors.SentTo.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                {/* {
                                  screenWidth < 770 ?
                                    <div className="mb-4 col-md-4 col-6">
                                      <label className="form-label">
                                        Sent{" "}
                                      </label>
                                      <div
                                        className="input-group me-3 flatpickr rounded flatpickr-input"
                                        readOnly="readonly"
                                      >
                                        <input
                                          className="form-control "
                                          type="datetime-local"
                                          placeholder="Select Date"
                                          aria-describedby="basic-addon2"
                                          min="1000-01-01T00:00"
                                          max="9999-12-31T23:59"
                                          disabled
                                          {...register("DtTime", {
                                          })}
                                        />
                                      </div>
                                      {errors.DtTime && (
                                        <div className="error">
                                          {errors.DtTime.message}
                                        </div>
                                      )}
                                    </div> : <></>
                                } */}


                                {/* form group */}
                                {/* <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Read{" "}
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      disabled
                                      {...register("ReadDtTm", {
                                      })}
                                    />
                                  </div>
                                  {errors.ReadDtTm && (
                                    <div className="error">
                                      {errors.ReadDtTm.message}
                                    </div>
                                  )}
                                </div> */}
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Subject
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="d-flex ">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter Subject"
                                      disabled={(notificationId||notificationIDParams) ? true : false}
                                      {...register("Subject", {
                                        required: "subject is required",
                                        validate: validateNoBlankSpaces,
                                      })}
                                    />
                                  </div>
                                  {errors.Subject && (
                                    <div className="error">
                                      {errors.Subject.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Description{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter Description"
                                    disabled={(notificationId || notificationIDParams) ? true : false}
                                    {...register("Description", {
                                      required: "description is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  ></textarea>
                                  {errors.Description && (
                                    <div className="error">
                                      {errors.Description.message}
                                    </div>
                                  )}
                                </div>

                                <div className="col-md-6 col-12 d-flex justify-content-lg-start justify-content-md-start justify-content-start  "  >
                                  <div className="form-label d-flex " style={{ marginBottom: "0px" }}>
                                    <div className="fw-normal " style={{ width: "45px" }}>
                                      Sent:{" "}

                                    </div>
                                    {formatDateTimetoAmPm(watchedFields?.DtTime)}
                                  </div>
                                  {/* <div
                                        className="input-group me-3 flatpickr rounded flatpickr-input"
                                        readOnly="readonly"
                                      >
                                        <input
                                          className="form-control "
                                          type="datetime-local"
                                          placeholder="Select Date"
                                          aria-describedby="basic-addon2"
                                          min="1000-01-01T00:00"
                                          max="9999-12-31T23:59"
                                          disabled
                                          {...register("DtTime", {
                                          })}
                                        />
                                      </div> */}
                                  {errors.DtTime && (
                                    <div className="error">
                                      {errors.DtTime.message}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-6 col-12 d-flex justify-content-lg-end justify-content-md-end justify-content-start">
                                  <label className="form-label d-flex">
                                    <div className="fw-normal" style={{ width: "45px" }}>
                                      Read:{" "}
                                    </div>
                                    {formatDateTimetoAmPm(watchedFields?.ReadDtTm)}
                                  </label>
                                  {/* <div
                                        className="input-group me-3 flatpickr rounded flatpickr-input"
                                        readOnly="readonly"
                                      >
                                        <input
                                          className="form-control "
                                          type="datetime-local"
                                          placeholder="Select Date"
                                          aria-describedby="basic-addon2"
                                          min="1000-01-01T00:00"
                                          max="9999-12-31T23:59"
                                          disabled
                                          {...register("ReadDtTm", {
                                          })}
                                        />
                                      </div> */}
                                  {errors.ReadDtTm && (
                                    <div className="error">
                                      {errors.ReadDtTm.message}
                                    </div>
                                  )}
                                </div>

                                <div className="d-flex justify-content-between pb-6  gap-4 ">
                                  <div className=" d-flex   w-100"></div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="mt-4  justify-content-between gap-4 d-flex  ">
                            <div className="left d-flex flex-wrap gap-3 align-items-center">
                              <div
                                className="btn btn-outline-danger "
                                style={{ height: "fit-content" }}
                                onClick={() => {
                                  if (notifictionType === "dashboard_notification") {
                                    navigate("/")
                                  }
                                  else {
                                    refetchNotificationList();
                                    setActiveTab("notifictionList");
                                    if(isStaffNotification){
                                      navigate("/notification")
                                    };
                                    handleTitleChnage();
                                    if (TranMID) {
                                      detailRefetch();
                                    }
                                  }
                                }}
                              >
                                Cancel
                              </div>
                            </div>

                            <div className="d-flex right align-items-center">
                              {!(notificationId && notificationIDParams) && (
                                <button
                                  className="  btn btn-primary  "
                                // disabled={
                                //   projectId
                                //     ? !(
                                //       (notificationStatus === "Pending" ||
                                //         notificationStatus ===
                                //         "In Process") &&
                                //       (
                                //         userInfo?.user_code ===
                                //         ProjectAllocBy ||
                                //         userInfo?.user_code ===
                                //         ProjectLead ||
                                //         userInfo?.user_code ===
                                //         TaskAllocBy ||
                                //         userInfo?.user_code ===
                                //         TaskLead ||
                                //         isAdmin(userInfo))
                                //     )
                                //     : false
                                // }
                                >
                                  Save
                                </button>
                              )}
                            </div>
                          </div>
                        </form>
                      );

                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default AddNotification;
